var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query.branch && !_vm.$route.query.company)?_c('BranchLoyaltyConfig'):_c('CompanyLoyaltyConfig')
}
var staticRenderFns = []

export { render, staticRenderFns }